export default __webpack_public_path__ + "static/media/profile-3.465320e0.png";